export const blue50 = "#e8f2fc";
export const blue100 = "#d6e8fa";
export const blue200 = "#add1f5";
export const blue300 = "#85baf0";
export const blue400 = "#5ca3eb";
export const blue500 = "#348de6";
export const blue600 = "#2975e0";
export const blue700 = "#1f5ddb";
export const blue800 = "#1545d4";
export const blue900 = "#0a2dcf";
export const blue1000 = "#0218ba";
export const blueA100 = "#5de8fa";
export const blueA200 = "#4ec6f2";
export const blueA400 = "#1a54d9";
export const blueA500 = "#040cc6";
export const blueA1000 = "#123150";
